import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { UsersService } from 'src/app/private/services/users.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-user',
  imports: [SharedModule],
  templateUrl: './delete-user.component.html',
  styleUrl: './delete-user.component.scss'
})
export class DeleteUserComponent {
    @Output() closeDialog = new EventEmitter<any>();
    @Output() reload = new EventEmitter<any>();
    @Input() userDataToEdit: any = {};
    isLoading : boolean = false;
  
    constructor(
      private api : UsersService,
      private localStorage: LocalStorageService,
      private messageService: MessageService
    ) { }


    handleCloseDialog() {
      this.closeDialog.emit();
    }

    deleteAccount() {
      this.isLoading = true;
      const payload = {
        ...this.userDataToEdit,
        status: 'Suspended'
      }
      this.api.updateUser(payload).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User deleted successfully' });
          this.reload.emit();
          this.handleCloseDialog();
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete user' });
          this.isLoading = false;
        }
      })
    }
  

}
